<template>
  <section class="main-box">
    <el-row>
      <el-col :span="24" class="q-title">
        <div class="q-title"><i></i>{{formObj.discloseName}}-交底单</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="q-mes">
        <el-row>
          <el-col :span="24" class="q-mes-f">项目名称：{{formObj.discloseName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">单位工程名称：{{formObj.discloseProName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">施工部位：{{formObj.discloseConsPosition}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f">分部工程/分项：{{formObj.code.name}}</el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="q-tab-title">
        <div class="q-tab-title"><i></i>通用交底：</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="q-w">
          {{formObj.discloseCommon}}
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="q-tab-title">
        <div class="q-tab-title"><i></i>专用交底：</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="q-w">
          {{formObj.discloseSpecial}}
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="q-mes">
        <el-row>
          <el-col :span="24" class="q-mes-f">交底人：{{formObj.employeeName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="q-mes-f"><div class="q-w">接受交底人：{{formObj.discloseAcceptUserN}}</div></el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-col :span="24" style="padding-top: 20px;">
      <el-button type="success" class="q-btn" v-on:click="openRealView">接受交底</el-button>
    </el-col>

    <el-dialog :visible.sync="realVisible" title="我的信息" :modal="false" width="80%">
      <el-form :model="mForm"  :rules="mRules" ref="mForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="mForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="code">
          <el-input v-model="mForm.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" class="q-btn" v-on:click="doReal">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>

  import {discloseDetail,updateByuseranddis} from '../../api/api'
  export default {
    name: 'discloseview',
    data(){
      return{
        realVisible:false,
        mForm:{},
        mRules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '请输入身份证号码', trigger: 'blur'}
          ]
        },
        formObj:{ code:{name:''}},
        submitObj:{},
        detailId:0
      }
    },
    methods: {
      getURLParam: function (paraName) {
        var url = document.location.toString()
        var arrObj = url.split('?')
        if (arrObj.length > 1) {
          var arrPara = arrObj[1].split('&')
          var arr
          for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=')
            if (arr != null && arr[0] == paraName) {
              return arr[1]
            }
          }
          return ''
        } else {
          return ''
        }
      },
      openRealView:function(){
        this.mForm = {};
        this.realVisible=true;
      },
      doReal:function(){
        this.$refs.mForm.validate((valid) => {
          if (valid) {
              this.submitObj.userId = null;
              this.submitObj.userCode = this.mForm.code
              this.submitObj.reId = this.detailId;
              this.submitObj.parent = 0;
              this.submitObj.replyPhoto = "";
              updateByuseranddis(this.submitObj,this.GLOBAL.header).then(result=>{
                  if(result.success)
                  {
                    this.$message({
                      message: "成功",
                      type: 'success'
                    });

                  }else {
                    this.$message({
                      message: "身份证有误",
                      type: 'error'
                    });
                  }
                this.realVisible=false;
              });
          }
        });
      }
    },
    mounted () {
      this.detailId = this.getURLParam('id');
      let param = {
        id: this.detailId
      };
      discloseDetail(param,this.GLOBAL.header).then(result=>{
        if(result.success){
          this.formObj = result.data;
          if(this.formObj==null)
          {
            this.$router.push('/');
          }
        }
        else{
          this.$router.push('/');
        }
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/qrcodeview/Discloseview.vue